import { render } from "./SuccessfullyCompletedNotice.vue?vue&type=template&id=5aeeb45c"
import script from "./SuccessfullyCompletedNotice.vue?vue&type=script&lang=ts"
export * from "./SuccessfullyCompletedNotice.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./SuccessfullyCompletedNotice.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script